import Vue from 'vue'
import get from 'lodash/get'
import moment from 'moment'

require('number-to-locale-string')
const EVENT_TYPES = require('./lang/events.json')

const filters = {
  get,
  fullName (user) {
    if (!user) return '–'
    return `${user.second_name} ${user.first_name} ${user.third_name}`
  },
  formatDate (date, format = 'DD.MM.YYYY HH:mm:ss (Z)') {
    return date
      ? moment.parseZone(date).format(format)
      : date
  },
  formatDateFromNow (date, removeSuffix = false) {
    return date
      ? moment.parseZone(date).fromNow(removeSuffix)
      : date
  },
  formatDuration (seconds) {
    if (!seconds) return '0'
    return moment().subtract(seconds, 'seconds').fromNow(true)
  },
  weekdayLabel (i) {
    return moment().weekday(i).format('dd')
  },
  formatRub (number) {
    return `${number} Р.`
  },
  eventName (code) {
    return EVENT_TYPES[code].split('|')[0]
  },
  simChannel (channel) {
    const messages = {chip: 'SIM-чип', card: 'SIM-карта'}
    return get(messages, channel)
  },
  round (value, precision) {
    const m = Math.pow(10, precision)
    return Math.round(parseFloat(value) * m) / m
  },
  remainder (value) {
    return filters.round(value, 4)
  },
}

export default filters

for (let filter in filters) {
  Vue.filter(filter, filters[filter])
}



// WEBPACK FOOTER //
// ./resources/assets/js/filters.js